export class AppConstants {
  public static get extraSmall(): string {
    return 'xs';
  }

  public static get small(): string {
    return 'sm';
  }

  public static get feedbackUrl(): string {
    return 'https://forms.office.com/r/9ifweW89NV';
  }

  public static get localFaviconUrl(): string {
    return 'https://www.cfacdn.com/img/Spotlight/Icons/Location_Marker.png';
  }

  public static get qaFaviconUrl(): string {
    return 'https://www.cfacdn.com/img/Spotlight/Icons/QA_Favicon_Icon_Black.svg';
  }

  public static get productionFaviconUrl(): string {
    return 'https://www.cfacdn.com/img/Spotlight/Icons/CFA_Favicon_Red_Square.svg';
  }

  public static get genericApiError(): string {
    return 'Something went wrong. Please check your internet connection and try again later.';
  }

  public static get genericNetworkError(): string {
    return 'We could not reach the server. Please check your internet connection and try again.';
  }

  public static get rewardTimeoutError(): string {
    return 'Oh no, it looks like your session has timed out. Please check calendar in five minutes to verify if the ' +
      'reward was sent before trying to resend.';
  }

  public static get eventTimeoutError(): string {
    return 'Oh no, it looks like your session has timed out. Please check calendar in five minutes to verify if the ' +
      'event was sent before trying to resend.';
  }

  public static get emailTimeoutError(): string {
    return 'Oh no, it looks like your session has timed out. Please check calendar in five minutes to verify if the ' +
      'email was sent before trying to resend.';
  }

  public static get genericTimeoutError(): string {
    return 'Oh no, it looks like your session has timed out. Please try again.';
  }

  public static get signatureMembership(): string {
    return 'signatureMembership';
  }

  // LaunchDarkly key is 'customer-qr-code-search'; the client SDK exposes keys camelCased by default
  public static get customerQrCodeSearchFlag(): string {
    return 'customerQrCodeSearch';
  }

  public static get customerQrCodeSearchFlagKey(): string {
    return 'customer-qr-code-search';
  }

  public static get calendarSearchFeature(): string {
    return 'calendarSearch';
  }

  public static get meetPage(): string {
    return 'meet';
  }

  public static get engagePage(): string {
    return 'engage';
  }

  public static get digitalRefundsFlag(): string {
    return 'digitalRefund';
  }

  public static get maintenanceFlag(): string {
    return 'maintenanceSpotlight';
  }

  public static get maintenanceWindow(): string {
    return 'maintenanceWindow';
  }

  public static get operatorPlaceholderImageUrl(): string {
    return 'https://static.cfacdn.com/photos/people/null.jpg';
  }
}
